import { render } from "./PromoSlider.vue?vue&type=template&id=4017cb96&scoped=true"
import script from "./PromoSlider.vue?vue&type=script&lang=js"
export * from "./PromoSlider.vue?vue&type=script&lang=js"

import "./PromoSlider.vue?vue&type=style&index=0&id=4017cb96&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4017cb96"]])

export default __exports__